import { useLazyQuery } from "@apollo/client";
import { createStyles, makeStyles } from "@material-ui/core";
import { DefaultInfo } from "components/NothingRight";
import { ShowOrderParcel } from "domains/Task/components/Job/dialogs";
import { OrderById } from "domains/Task/graphql/queries";
import React from "react";
import "styled-components/macro";
import { RecapView } from "./NewOrderDetails";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: "100%",
      padding: "16px",
      height: "100%",
      overflow: "auto",
      overflowX: "hidden",
      backgroundColor: "#fff",
    },
  })
);
interface OrderDetailsProps {
  orderId: string;
}

export function OrderDetails({ orderId }: OrderDetailsProps) {
  const styles = useStyles();
  const [showParcels, setShowParcels] = React.useState(false);
  const [queryOrderById, { data }] = useLazyQuery(OrderById);

  React.useEffect(() => {
    if (orderId) {
      queryOrderById({
        variables: { params: { id: orderId } },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);
  const dataToShow = data?.orderById?.data;

  return (
    <div className={styles.root}>
      {dataToShow ? <RecapView order={dataToShow} /> : <DefaultInfo />}
      <ShowOrderParcel order={dataToShow} open={showParcels} handleClose={() => setShowParcels(false)} />
    </div>
  );
}
